import { render, staticRenderFns } from "./DetailPemutakhiranHabisMasaBerlaku.vue?vue&type=template&id=6a24dc36&"
import script from "./DetailPemutakhiranHabisMasaBerlaku.vue?vue&type=script&lang=js&"
export * from "./DetailPemutakhiranHabisMasaBerlaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports